var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuGameColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 22,
    viewBox: "0 0 38 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2761 21.9767C23.1909 21.992 23.1038 22 23.0155 22H20.2401L20.2302 22H12.4533L12.4451 22H0L3.05536 11.6457C3.85271 8.94357 6.33378 7.08886 9.15107 7.08886H14.584C15.5305 5.05935 17.5837 3.70373 19.9007 3.70372L25.1843 3.70371C25.8957 1.52654 27.9386 0 30.2954 0H37.8889L32.7068 20.8865C32.5445 21.5407 31.9573 22 31.2833 22H23.4899C23.4162 22 23.3447 21.9919 23.2761 21.9767Z",
    fill: "#0A3480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79163 12.8738C4.58716 10.1689 7.06955 8.31152 9.88893 8.31152H14.4224L11.0653 19.7254C10.8818 20.3496 10.3089 20.7782 9.65827 20.7782H1.4668L3.79163 12.8738Z",
    fill: "url(#paint0_linear_1455_14888)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79163 12.8738C4.58716 10.1689 7.06955 8.31152 9.88893 8.31152H14.4224L1.4668 20.7782L3.79163 12.8738Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.921 9.08967C15.6326 6.48037 18.0358 4.69569 20.7394 4.76877L25.1778 4.88872L21.3088 19.6821C21.14 20.3274 20.5569 20.7776 19.8898 20.7776H13.0135C12.3688 20.7776 11.9005 20.1646 12.0702 19.5426L14.921 9.08967Z",
    fill: "url(#paint1_linear_1455_14888)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0781 4.66223C26.6953 2.22282 28.9215 0.537517 31.4369 0.6055L36.1784 0.733648L31.5625 19.659C31.4022 20.3159 30.8137 20.7781 30.1376 20.7781H23.2566C22.6193 20.7781 22.1524 20.1783 22.3087 19.5605L26.0781 4.66223Z",
    fill: "url(#paint2_linear_1455_14888)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M15 9.5C15.7955 6.79519 17.6028 5 20.4221 5H24.9556L12.5 18L15 9.5Z",
    fill: "white",
    fillOpacity: 0.98
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26 5.5C26.7955 2.79519 28.1806 1 31 1H36L23.5 14.5L26 5.5Z",
    fill: "white",
    fillOpacity: 0.98
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_14888",
    x1: 7.94457,
    y1: 8.31152,
    x2: 7.94457,
    y2: 20.7782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8CB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_14888",
    x1: 18.4556,
    y1: 4.64438,
    x2: 18.4556,
    y2: 20.7777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A950FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4A9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1455_14888",
    x1: 29.0893,
    y1: 0.489171,
    x2: 29.0893,
    y2: 20.7781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4FF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FF9A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuGameColor);
export default __webpack_public_path__ + "static/media/menu-game-color.be9aa77c63cf8303ee598d7be7571e67.svg";
export { ForwardRef as ReactComponent };